import Stack from '@mui/material/Stack'
import {
  DataGridToolbarContainer,
  DataGridToolbarResetFilteringButton,
  DataGridToolbarResetSortingButton
} from '@cbgms/components/list/DataGridToolbar'
import { SearchFilter, SearchFilterProps } from '../fields/SearchFilter'

export function DataGridToolbarWithSearch(props: SearchFilterProps) {
  return (
    <DataGridToolbarContainer>
      <Stack direction='row' spacing={1} justifyContent='space-between' flex='1 1 auto'>
        <SearchFilter {...props} />
        <Stack direction='row' spacing={1} sx={{ marginLeft: 'auto' }}>
          <DataGridToolbarResetSortingButton />
          <DataGridToolbarResetFilteringButton />
        </Stack>
      </Stack>
    </DataGridToolbarContainer>
  )
}
